import dotenv from 'dotenv'
dotenv.config()

import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import VueI18n from 'vue-i18n'
import { numberFormats } from '@/i18n/default.numberFormats'
import store from '@/store/index.js'
import router from '@/router'

import {} from './API'
import {} from './APITemp'

window.LOG_LEVEL='DEBUG'

Vue.config.productionTip = false
Vue.use(VueI18n, numberFormats)

store.dispatch('init').then(() => {
    /* eslint-disable no-new */

    let app = new Vue({
        el: '#app',
        store,
        router,
        vuetify,
        i18n: new VueI18n({
            numberFormats
        }),
        render: h => h(App)
    });
    app.$i18n.locale = store.getters['locale']
})